import { AfterViewInit, ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { DataServiceService } from 'src/app/core/helpers/data-service.service';

@Component({
    selector: 'loyaltic-no-win',
    templateUrl: './no-win.component.html',
    styleUrls: ['./no-win.component.scss'],
    standalone: false
})
export class NoWinComponent implements OnInit, AfterViewInit {

  @ViewChild('noWinPopupWithReceipt', { static: false }) noWinPopupWithReceiptRef: any;

  public modalRef: BsModalRef;
  popupConfig = {
    ignoreBackdropClick: true,
    class: 'lyltc win modal-md modal-dialog-centered',
  };

  winDetails: any;
  culture = '';
  showSurvey = true;

  constructor( private modalService: BsModalService,
    public translate: TranslateService,
    public dataService: DataServiceService,
    private router: Router) {
      this.culture = translate.getDefaultLang();
      this.winDetails = this.dataService.getWinDetails();
      console.log("this.winDetails",this.winDetails)
  }
  ngOnInit() {
    if(localStorage.getItem('surveyTaken') == 'true') {
      this.showSurvey = false;
    }
  }

  ngAfterViewInit() {
    this.modalRef = this.modalService.show(this.noWinPopupWithReceiptRef, this.popupConfig);

  }

  playAgain() {
    localStorage.setItem('playAgain','true')
    this.modalRef.hide()
    this.router.navigate(['play'])
  }
  redirectToUpload() {
    this.modalRef.hide()
    this.router.navigate(['/enter-code'])
  }

  newMessage() {
    this.dataService.changeMessage("Hello from Second Component")
  }
  surveyTaken() {
    localStorage.setItem('surveyTaken','true')
  }
}
